import React, { Component } from 'react'
import { Button, Spinner,Toast} from "react-bootstrap-v5";
import { toast } from "react-toastify";

import SimpleReactValidator from 'simple-react-validator';
import JobService from "../../../Services/JobService";
import helperFunction from '../../../Function/helperFunction';
import { paymmentInformation } from '../../../Function/defaultJobOptions'

import QuickInfo  from './JobForms/QuickInfo'
import Customerinfo  from './JobForms/CustomerInfo'
import Receiverinfo  from './JobForms/ReceiverInfo'
import Shipment  from './JobForms/Shipment'
import Schedule  from './JobForms/Schedule'
import Carrier  from './JobForms/Carrier'
import AddOns from './JobForms/AddOns'
import Cargo from './JobForms/Cargo'
// import Revenue from './JobForms/Revenue'
// import Cost from './JobForms/Cost'
import RevenueAndCost from './JobForms/RevenueAndCost'
import Documents from './JobForms/Documents'
import Retailer from './JobForms/Retailer'


const tabWidth = {
    width: '84%'
}

class AddJobCard extends Component {

    constructor() {
        super()
        this.validator = new SimpleReactValidator()

        this.state = {
            buttonSubmit: true,
            validationToast: false,
            errorMsgs:[],
            bookingAmount: 0,
            originData: {},
            destinationData: {},
            jobData:{
                deliverer:"",
                quote_token: helperFunction.stdToken(),
                is_job_open:"OPEN",
                customer_details: {
                    "email": "",
                    "mobile_number": "",
                    "name": "",
                    "sales_person": "",
                    "address": "",
                    "taxation_detail": "",
                    "user_type": "",
                },
                general_details: {
                    "customer_service": "",
                    "customer_type": "",
                    "end_customer_type": "",
                    "overseas_agent": "",
                    "shipment_category": "",
                    "retailer_id": "",
                    "retailer_name": "",
                    "sales_person" : "",
                    "referral_code": "",
                },
                receiver_details: {
                    "receiver_name": "",
                    "pickup_contact": "",
                    "email": "",
                    "address": "",
                    "country": "",
                    "state": "",
                    "city": "",
                    "postal_code": "",
                    "comments": ""
                },
                shipment_details: {
                    "origin": "",
                    "origin_country": "",
                    "destination": "",
                    "destination_country": "",
                    "value_of_goods": 0,
                    "shipment_type": "",
                    "shipment_mode": "",
                    "servic_type": ""
                },
                schedule_pickup : {
                    comments: '',
                    pickup: [
                        {
                            "pickup_shipment" : "", 
                            "salutation" : "", 
                            "sender_name" : "", 
                            "pickup_contact" : "", 
                            "pickup_date" : "", 
                            "pickup_time" : "", 
                            "address" : "", 
                            "pickup_country": "",
                            "pickup_state": "",
                            "pickup_city": "",
                            "pickup_postal_code": "",
                            "email" : "", 
                            "delevered_by" : "", 
                            "invoice_no" : ""
                        }
                    ]
                },
                carrier_details : {
                    "m_awb_m_b_l":'',
                    "m_awb_h_b_l":'',
                    "carrier_name":'',
                    "port_of_entry":'',
                    "shipment_type":'',
                    "comments":'',
                },
                add_ons: {
                    /* insurance:0,
                    storage:0, */
                    "insurance": {
                        insurance_amount: 0,
                        insurance_premium: 0,
                        items_goods: 0,
                        minimum_aed: 0
                    },
                    "storage": {
                        handling_in: 0,
                        handling_out: 0,
                        minimum: 0,
                        storage_amount: 0,
                        storage_charges: 0,
                        storage_value: 0
                    },
                    "comments":'',
                },
                payment_information: paymmentInformation(),
                quote_request_items:[
                    {
                        actual: {
                            freight_charges: 0,
                            height: 0,
                            item_description: "",
                            kilogram: 0,
                            length: 0,
                            no_of_pkgs: 0,
                            packing_charges: 0,
                            total_volume_CBM: 0,
                            total_weight_KG: 0,
                            width: 0,
                        },
                        add_ons_items: {
                            freight_charges: 0,
                            height: 0,
                            item_description: "",
                            kilogram: 0,
                            length: 0,
                            no_of_pkgs: 0,
                            packing_charges: 0,
                            total_volume_CBM: 0,
                            total_weight_KG: 0,
                            width: 0,
                        },
                        booking: {
                            freight_charges: 0,
                            height: 0,
                            item_description: "",
                            kilogram: 0,
                            length: 0,
                            no_of_pkgs: 0,
                            packing_charges: 0,
                            total_volume_CBM: 0,
                            total_weight_KG: 0,
                            width: 0,
                        },
                        item_token: helperFunction.stringGenerator(24)
                    }
                ],
                cargo_details:{
                    booking: [{
                        "description": "",
                        "package": "",
                        "weight": "",
                        "length": "",
                        "width": "",
                        "height": ""
                    }],
                    actual: [{
                        "description": "",
                        "package": "",
                        "weight": "",
                        "length": "",
                        "width": "",
                        "height": ""
                    }]
                },
                document:{
                    customer_document:[{
                        "document_name": "",
                        "document_type": "",
                        "document": "",
                        "document_file": [
                            
                        ]
                    }],
                    store_document:[{
                        "document_name": "",
                        "document_type": "",
                        "document": "",
                        "document_file": [
                            
                        ]
                    }]
                }

            }
        }
    }

    componentDidMount = () => {
        const employee = localStorage.getItem('emp_name');
        let data = JSON.parse(JSON.stringify(this.state.jobData))
        if(employee){
            data.general_details.customer_service = employee
            this.setState({ jobData: data });
        }
      };

    
    handleChangeValue = (event, objKey, objInnerKey='') => {
        let fieldKey = objInnerKey != '' ? objInnerKey : event.target.name
        let fieldValue = event.value == undefined ? event.target.value  : event.value
        
        // console.log(fieldKey,'fieldKey',objKey, 'fieldValue',fieldValue)
        let jobCardData = this.state.jobData

        if(fieldKey==="user_id"){
            jobCardData.user_id = fieldValue;
        }
        
        if (fieldKey === 'quote_request_items' || fieldKey === 'retailer_details' || fieldKey === 'is_job_open' || fieldKey === 'general_details' || fieldKey === 'deliverer') {
            jobCardData[objKey] = fieldValue
        } else if(fieldKey === 'insurance' || fieldKey === 'storage') {
            jobCardData[objKey][fieldKey][event.name] = fieldValue
        } else {
            jobCardData[objKey][fieldKey] = fieldValue
            if(fieldKey == 'insurance_opted' && fieldValue == 'no'){
                delete jobCardData[objKey]['insurance_applied'];
                delete jobCardData[objKey]['insurance_policy_received'] ;
               }else if(fieldKey == 'insurance_applied' && fieldValue == 'no'){
                 delete jobCardData[objKey]['insurance_policy_received'] ;
               }
        }
        this.setState(jobCardData)
    }

    handleOringDestination = (e, objKey) => {
        let jobCardData = this.state.jobData
        jobCardData[objKey] = {...jobCardData[objKey],...e}
        this.setState(jobCardData)
    }

    handleChangeOriginDestination = (type, data) => {
        this.setState({[type]: data})
    }

    resetAddOnPayment = () => {
        let jobCardData = this.state.jobData
        jobCardData.payment_information = paymmentInformation()
        jobCardData.add_ons.insurance = {
            insurance_amount: 0,
            insurance_premium: 0,
            items_goods: 0,
            minimum_aed: 0
        }

        jobCardData.add_ons.storage = {
            handling_in: 0,
            handling_out: 0,
            minimum: 0,
            storage_amount: 0,
            storage_charges: 0,
            storage_value: 0
        }
        
        this.setState(jobCardData)
    }

    validateCargoFields = (paramdata) => {
        let invalidFields = paramdata.filter((item1)=> {
            return (
            ((Number(item1.actual.no_of_pkgs) === 0 || Number(item1.actual.no_of_pkgs) === "") 
            || (item1.actual.item_description === "")
            || (Number(item1.actual.height) === 0 ||   item1.actual.height === "")
            || (Number(item1.actual.width) === 0 ||    item1.actual.width === "")
            || (Number(item1.actual.length) === 0 ||   item1.actual.length === "")
            || (Number(item1.actual.kilogram) === 0 || item1.actual.kilogram === "")) 
            ||
            ((Number(item1.booking.no_of_pkgs) === 0 || Number(item1.booking.no_of_pkgs) === "") 
            || (item1.booking.item_description === "")
            || (Number(item1.booking.height) === 0 ||   item1.booking.height === "")
            || (Number(item1.booking.width) === 0 ||    item1.booking.width === "")
            || (Number(item1.booking.length) === 0 ||   item1.booking.length === "")
            || (Number(item1.booking.kilogram) === 0 || item1.booking.kilogram === "")))
        })
        if(paramdata.length === 1 && invalidFields.length === 1){
            return false
        }else{
            return invalidFields.length > 0
        }
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.setState({buttonSubmit: false})
        if (this.validator.allValid()) {
            let postData = this.state.jobData
            if(this.validateCargoFields(postData.quote_request_items)){
                toast.error("Please fill cargo required fields")
                this.setState({ buttonSubmit: true })
                return false
            }
            postData.job_id = this.state.jobData._id
            postData.customer_details.mobile_number = postData.customer_details.mobile_number.split('+')[1]
            postData.customer_details.email = postData.customer_details.email.toLowerCase()
            postData.receiver_details.email = postData.receiver_details.email.toLowerCase()
            JobService.addJobservice(postData).then((result) => {
                if (result.status === true) {;
                    toast.success(result.message);
                    this.props.history.push('/job-list')
                }
                
            });
            this.setState({buttonSubmit: true})
        } else {
            this.setState({validationToast:true})
            this.validator.showMessages();
            // rerender to show messages for the first time
            // you can use the autoForceUpdate option to do this automatically`
            this.forceUpdate();
            this.setState({buttonSubmit: true})
        }
    }

    render() {
        const { jobData, buttonSubmit, validationToast, errorMsgs } = this.state
        // console.log(jobData,'jobData add')
        return (
            <>
                <form className="control-form" onSubmit={this.onSubmit}>

                <QuickInfo 
                    isview={true}
                    onChangeValue={this.handleChangeValue}
                    jobCustData={jobData.customer_details}
                    jobShipmentData={jobData.shipment_details}
                    jobToken={jobData.job_token}
                    isJobOpen={jobData.is_job_open}
                    paymentInformation={jobData.payment_information}
                    generalDetails={jobData.general_details}
                    formValidator={this.validator}
                    stateData={{jobFinancialStatus:true, isDraftedInvoice:true , isDraftedCost:true}}
                />

                <div className="d-flex align-items-start">

                    <div className="nav flex-column nav-pills me-3 bg-white" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                        
                        <button className="nav-link active" id="v-pills-home-tab" data-bs-toggle="pill" data-bs-target="#v-pills-home" type="button" role="tab"  aria-selected="true">Customer Info</button>

                        <button className="nav-link" id="v-pills-profile-tab" data-bs-toggle="pill" data-bs-target="#v-pills-profile" type="button" role="tab" aria-selected="false">Receiver Info</button>

                        <button className="nav-link" id="v-pills-shipment-tab" data-bs-toggle="pill" data-bs-target="#v-pills-shipment" type="button" role="tab"  aria-selected="false">Shipment Summary</button>

                        <button className="nav-link" id="v-pills-cargo-tab" data-bs-toggle="pill" data-bs-target="#v-pills-cargo" type="button" role="tab" aria-selected="false">Cargo Details</button>

                        <button className="nav-link" id="v-pills-addons-tab" data-bs-toggle="pill" data-bs-target="#v-pills-addons" type="button" role="tab" aria-selected="false">Add Ons</button>

                        <button className="nav-link" id="v-pills-schedule-tab" data-bs-toggle="pill" data-bs-target="#v-pills-schedule" type="button" role="tab" aria-selected="false">Schedule Pickup</button>

                        <button className="nav-link" id="v-pills-carrier-tab" data-bs-toggle="pill" data-bs-target="#v-pills-carrier" type="button" role="tab" aria-selected="false">Carrier Details</button>

                        {/* <button className="nav-link" id="v-pills-revenue-tab" data-bs-toggle="pill" data-bs-target="#v-pills-revenue" type="button" role="tab" aria-selected="false">Revenue And Cost</button> */}

                        {/* <button className="nav-link" id="v-pills-cost-tab" data-bs-toggle="pill" data-bs-target="#v-pills-cost" type="button" role="tab" aria-selected="false">Cost</button> */}

                        <button className="nav-link" id="v-pills-document-tab" data-bs-toggle="pill" data-bs-target="#v-pills-document" type="button" role="tab" aria-selected="false">Documents</button>

                        <button className="nav-link" id="v-pills-retailer-tab" data-bs-toggle="pill" data-bs-target="#v-pills-retailer" type="button" role="tab" aria-selected="false">Retailer</button>

                    </div>

                    <div className="tab-content" id="v-pills-tabContent" style={tabWidth}>
                        <div className="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
                            <Customerinfo 
                                onChangeValue={this.handleChangeValue} 
                                jobData={jobData.customer_details} 
                                formValidator={this.validator}
                            />
                        </div>

                        <div className="tab-pane fade" id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab">
                            <Receiverinfo 
                                onChangeValue={this.handleChangeValue} 
                                jobData={jobData.receiver_details} 
                                formValidator={this.validator}
                            />
                        </div>

                        <div className="tab-pane fade" id="v-pills-shipment" role="tabpanel" aria-labelledby="v-pills-shipment-tab">
                            <Shipment 
                                onChangeValue={this.handleChangeValue}
                                handleResetAddOnPayment={this.resetAddOnPayment}
                                jobData={jobData.shipment_details}
                                jobItems={jobData.quote_request_items}
                                quoteToken={jobData.quote_token}
                                paymentInformation={jobData.payment_information}
                                handleChangeOrgDest={this.handleChangeOriginDestination}
                                formValidator={this.validator}
                                handleOringDestination={this.handleOringDestination}
                            />
                        </div>

                        <div className="tab-pane fade" id="v-pills-cargo" role="tabpanel" aria-labelledby="v-pills-cargo-tab">
                            <Cargo 
                                onChangeValue={this.handleChangeValue}
                                jobData={jobData.quote_request_items}
                                removeBookingCount={this.state.removeBookingCount}
                                jobShipmentData={jobData.shipment_details}
                                quoteToken={jobData.quote_token}
                                originData={this.state.originData}
                                destinationData={this.state.destinationData}
                                paymentInformation={jobData.payment_information}
                                formValidator={this.validator}
                            />
                        </div>

                        <div className="tab-pane fade" id="v-pills-schedule" role="tabpanel" aria-labelledby="v-pills-schedule-tab">
                            <Schedule 
                                onChangeValue={this.handleChangeValue}
                                jobData={jobData.schedule_pickup}
                                totalJobData={jobData} 
                                formValidator={this.validator}
                            />
                        </div>

                        <div className="tab-pane fade" id="v-pills-carrier" role="tabpanel" aria-labelledby="v-pills-carrier-tab">
                            <Carrier 
                                onChangeValue={this.handleChangeValue} 
                                jobData={jobData.carrier_details} 
                                formValidator={this.validator}
                            />
                        </div>

                        <div className="tab-pane fade" id="v-pills-addons" role="tabpanel" aria-labelledby="v-pills-addons-tab">
                            <AddOns 
                                onChangeValue={this.handleChangeValue}
                                jobData={jobData.quote_request_items}
                                jobCargoData={jobData.cargo_details}
                                addOns={jobData.add_ons}
                                jobShipmentData={jobData.shipment_details}
                                generalDetails={jobData.general_details}
                                quoteToken={jobData.quote_token}
                                originData={this.state.originData}
                                destinationData={this.state.destinationData}
                                paymentInformation={jobData.payment_information}
                                prevItemCount={this.state.removeBookingCount}
                                itemsBookingAmount={this.state.bookingAmount}
                                formValidator={this.validator}
                            />
                        </div>

                        

                        <div className="tab-pane fade" id="v-pills-revenue" role="tabpanel" aria-labelledby="v-pills-revenue-tab">
                            {/* <Revenue onChangeValue={this.handleChangeValue} /> */}
                            <RevenueAndCost 
                                    onChangeValue={this.handleChangeValue}
                                    jobData={jobData.retailer_details}
                                    jobStatus='None'
                                    customerData={jobData.customer_details}
                                    receiverData={jobData.receiver_details}
                                    quoteToken={jobData.quote_token}
                                    carrierData={jobData.carrier_details}
                                    payInfoData={jobData.payment_information}
                                    jobId={jobData._id}
                                    formValidator={this.validator} 
                                />
                        </div>

                        {/* <div className="tab-pane fade" id="v-pills-cost" role="tabpanel" aria-labelledby="v-pills-cost-tab">
                            <Cost onChangeValue={this.handleChangeValue} />
                        </div> */}
                        <div className="tab-pane fade" id="v-pills-document" role="tabpanel" aria-labelledby="v-pills-document-tab">
                            <Documents 
                                onChangeValue={this.handleChangeValue}
                                jobData={jobData} 
                                formValidator={this.validator}
                            />
                        </div>

                        <div className="tab-pane fade" id="v-pills-retailer" role="tabpanel" aria-labelledby="v-pills-retailer-tab">
                            <Retailer 
                                onChangeValue={this.handleChangeValue}
                                jobData={jobData.retailer_details} 
                                formValidator={this.validator}
                            />
                        </div>
                        
                    </div>

                </div>

                <div class="row">
                    <div class="col-2"></div>
                    <div class="col-10">

                        
                        {buttonSubmit && <Button type="submit" variant="primary" size="lg">Submit</Button>}

                        {!buttonSubmit && 
                            <Button variant="primary" disabled>
                                <Spinner
                                as="span"
                                animation="grow"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                />
                                Loading...
                            </Button>
                        }

                        {
                            <Toast className="d-inline-block m-1 bg-danger" onClose={() => this.setState({validationToast:false})} show={validationToast} /* delay={3000} */ >
                                <Toast.Header>
                                    <strong className="me-auto">Errors</strong>
                                </Toast.Header>
                                <Toast.Body className='text-white'>
                                
                                {
                                    Object.keys(this.validator.getErrorMessages()).map(key=>{
                                        return <p>{this.validator.getErrorMessages()[key]}</p>
                                    })
                                    
                                }
                                </Toast.Body>
                            </Toast>
                        }

                    </div>
                </div>

                
                </form>

            </>
        )
    }
}

export { AddJobCard }